module.exports = __webpack_public_path__ + "static/img/Five of Swords.35696c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Five of Swords.jpg
// module id = 1267
// module chunks = 0